export const MAX_GUIDE_DEPTH = 6
export const MAX_GUIDE_NODES = 200
let sequence = 0
const newId = () => 'guide-' + Date.now().toString(36) + '-' + (++sequence).toString(36)
export const cloneGuide = content => JSON.parse(JSON.stringify(content))
export const newGuideItem = () => ({ id: newId(), title: '', text: '', tone: 'normal', points: [] })
export const newGuideSection = () => ({ id: newId(), title: '', items: [], children: [] })

export const flattenSections = (sections, parents = []) => (sections || []).reduce((rows, node) => {
  const path = [...parents, node]
  return [...rows, { node, path, depth: path.length }, ...flattenSections(node.children, path)]
}, [])
export const findSection = (sections, id) => {
  for (let index = 0; index < sections.length; index++) {
    const node = sections[index]
    if (node.id === id) return { node, siblings: sections, index }
    const match = findSection(node.children || [], id)
    if (match) return match
  }
  return null
}

// Classify legacy text in memory, preserving every paragraph. Persist only on
// explicit publication, protected by the existing per-language revision check.
export const normalizeGuide = (input, language = 'zh') => {
  const content = cloneGuide(input)
  const normalize = (sections, prefix) => (sections || []).map((section, index) => {
    const id = section.id || prefix + '-' + (index + 1)
    return { ...section, id, items: (section.items || []).map((item, i) => ({ ...item, id: item.id || id + '-item-' + (i + 1), points: item.points || [] })), children: normalize(section.children, id) }
  })
  const sections = normalize(content.sections, 'section')
  if (content.schemaVersion === 2) content.sections = sections
  else {
    const titles = language === 'en' ? ['Tutorials', 'Important Notes', 'Frequently Asked Questions'] : ['使用教程', '注意事项', '常见问题']
    content.sections = titles.map((title, index) => ({ id: 'guide-category-' + index, title, items: [], children: [] }))
    sections.forEach(section => {
      const category = /反馈|问题|索赔|争议|faq|feedback|problem|claim|dispute/i.test(section.title) ? 2 : /费用|押金|保证金|注意|fee|deposit|precaution|notice/i.test(section.title) ? 1 : 0
      content.sections[category].children.push(section)
    })
  }
  content.schemaVersion = 2
  return content
}

export const insertSection = (sections, targetId, position) => {
  if (flattenSections(sections).length >= MAX_GUIDE_NODES) return null
  const section = newGuideSection()
  if (position === 'root') {
    if (sections.length >= 20) return null
    sections.push(section)
  } else {
    const target = findSection(sections, targetId)
    if (!target) return null
    if (position === 'child') {
      const depth = flattenSections(sections).find(row => row.node.id === targetId).depth
      if (depth >= MAX_GUIDE_DEPTH || target.node.children.length >= 30) return null
      target.node.children.push(section)
    } else {
      if (target.siblings.length >= (target.siblings === sections ? 20 : 30)) return null
      target.siblings.splice(target.index + (position === 'before' ? 0 : 1), 0, section)
    }
  }
  return section
}
export const moveSection = (sections, id, direction) => {
  const target = findSection(sections, id)
  if (!target || target.index + direction < 0 || target.index + direction >= target.siblings.length) return false
  target.siblings.splice(target.index, 1)
  target.siblings.splice(target.index + direction, 0, target.node)
  return true
}
export const removeSection = (sections, id) => {
  const target = findSection(sections, id)
  if (!target || (target.siblings === sections && sections.length === 1)) return false
  target.siblings.splice(target.index, 1)
  return true
}
export const prepareGuide = draft => {
  const content = cloneGuide(draft)
  const prepare = sections => sections.forEach(section => {
    section.items.forEach(item => { item.points = item.points.map(point => point.trim()).filter(Boolean) })
    prepare(section.children || [])
  })
  prepare(content.sections)
  return content
}
